import React from 'react'


const Icon = ({value}) => {
    return <span className={`fas fa-${value}`}></span>
}

export default Icon